import * as React from 'react';

import { mergeStyles, OutsideClick } from '@cian/components';
import { DownloadIcon } from '../../icons/download';
import { trackClickOnDocxButton, trackClickOnMainButton, trackClickOnPDFButton } from './tracking';

import * as styles from './index.css';

export interface IExportButtonProps {
  pdfUrl: string;
  docxUrl: string;
}

export interface IExportButtonState {
  open: boolean;
  tooltip: boolean;
}

export class ExportButton extends React.Component<IExportButtonProps, IExportButtonState> {
  public constructor(props: IExportButtonProps) {
    super(props);

    this.state = {
      open: false,
      tooltip: false,
    };
  }

  public render() {
    const openClass = this.state.open ? styles['popup--open'] : '';

    return (
      <OutsideClick onOutsideClick={this.closePopup}>
        <div className={styles['button-container']}>
          <button
            className={styles['export-button']}
            onClick={this.handleClickButton}
            onMouseEnter={this.handleButtonMouseEnter}
            onMouseLeave={this.handleButtonMouseLeave}
            title="Экспорт"
          >
            <DownloadIcon className={styles['icon']} />
          </button>
          <div {...mergeStyles([styles['popup'], openClass])}>
            <div className={styles['link-container']}>
              <a
                download
                className={styles['link']}
                href={this.props.pdfUrl}
                onClick={() => {
                  this.closePopup();
                  trackClickOnPDFButton();
                }}
              >
                Скачать в PDF
              </a>
              <a
                download
                className={styles['link']}
                href={this.props.docxUrl}
                onClick={() => {
                  this.closePopup();
                  trackClickOnDocxButton();
                }}
              >
                Скачать в .docx
              </a>
            </div>
          </div>
        </div>
      </OutsideClick>
    );
  }

  private handleButtonMouseEnter = () => {
    this.setState({
      tooltip: true,
    });
  };

  private handleButtonMouseLeave = () => {
    this.setState({
      tooltip: false,
    });
  };

  private handleClickButton = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    trackClickOnMainButton();

    this.setState({
      open: !this.state.open,
    });
  };

  private closePopup = () => {
    this.setState({
      open: false,
    });
  };
}
